import React from "react";
const ArrowDownIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" fill="none">
    <path d="M6.5 9L12 14.5L17.5 9" stroke="currentColor" />
  </svg>
);
export default ArrowDownIcon;
